module.exports = __webpack_public_path__ + "static/MonarcaTekLogo-14f06ba4d895fc29bfe9d03665d15b1f.png";